import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";

import "react-tabs/style/react-tabs.css";
import TablaPuc from "./modalTablaPuc";
import axios from "axios";
import TablaCuenta from "./modalTablaCuenta";
import { Dimmer } from "../spinner";

import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, Radio, Textarea } from "../../ui/inputs/Input";

export const ActualizarTipopro = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2] = useState();
  const [msg2] = useState();
  const [activate, setActivate] = useState(false);
  const txtRadioSi = useRef();
  const txtRadioNo = useRef();
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [idefiscal] = useState(localStorage.getItem("idefiscal"));
  const txtDescrp = useRef();
  const txtIdc = useRef();
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [valuespuc, setValuespuc] = useState({
    idpuc: "0",
    descripcion: "",
    puc: "",
  });
  const [values, setValues] = useState({
    idtipoproducto: "",
    descripcion: "",
    informatica: "",
  });
  const [valuescnt, setValuesCnt] = useState({
    idcuenta: "",
    codigocu: "",
    descri: "",
  });

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/createCuentaConta/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdc.current.value) || 0,
      descrip: txtDescrp.current.value.trim(),
      idplan: valuespuc.idpuc,
      efis: parseInt(idefiscal),
      plan: valuespuc.puc,
      inform: txtRadioSi.current.checked ? true : false,
      idcta: valuescnt.idcuenta || 0,
    };
    console.log(body);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();

          if (props.operacion === 1) {
            setTitulo("Notificacion");
            setMsg("Registro Creado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 2) {
            setTitulo("Notificacion");
            setMsg("Registro Modificado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 3) {
            setTitulo("Notificacion");
            setMsg("Registro Eliminado Correctamente.");
            setMostrar(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtDescrp.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Debe Introducir la Descripción");
      sigue = false;
      txtDescrp.current.focus();
      setMostrar(true);
    } else if (sigue === true) {
      Actualizar(props.operacion);
    }
  };

  const handleCloseCatag = () => {
    setMostrar3(false);
  };

  const handleCloseCta = () => {
    setMostrar4(false);
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setActivate(false);
    setValues({
      idtipoproducto: "",
      descripcion: "",
      informatica: "",
    });
    setValuespuc({
      idpuc: "0",
      descripcion: "",
      puc: "",
    });
    setValuesCnt({
      idcuenta: "",
      codigocu: "",
      descri: "",
    });
    setTabIndex(0);
    setOperacion(0);
    setMsg("");
  };

  const onChange = (event) => {
    if (event.target.name === "descripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setHabilitadoNR(false);
    blanquear();
    props.onHideCancela();
  };

  const catalogoPuc = () => {
    setMostrar3(true);
  };

  const catalogoCuta = () => {
    setMostrar4(true);
  };

  const handleAceptarPuc = (valor) => {
    setMostrar3(false);
    console.log(valor);
    /*         txtIdPuc.current.value = valor.idP;
                txtDescpPuc.current.value = valor.descrip;
                txtPuc.current.value = valor.puc; */
    setValuespuc({
      ...values,
      idpuc: valor.idpuc,
      descripcion: valor.descripcion,
      puc: valor.puc,
    });
  };

  const handleAceptarCta = (valor) => {
    setMostrar4(false);
    console.log(valor);
    setValuesCnt({
      ...values,
      idcuenta: valor.idcu,
      codigocu: valor.codcuenta,
    });
  };

  const handlerClickTab = (index, lastIndex, event) => {
    if (operacion === 1 && (index === 2 || index === 3)) {
      setTabIndex(0);
    } else {
      setTabIndex(index);
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        setTabIndex(0);
        if (props.operacion !== 1) {
          setValues(props.tipopro);

          setValuesCnt(props.cuenta);
          if (props.puc) {
            setValuespuc(props.puc);
          }

          console.log(props.tipopro);
          console.log(props.cuenta);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Tipo."
            : operacion === 2
              ? "Modificar Tipo."
              : operacion === 3
                ? "Eliminar Tipo."
                : "Consultar Tipo."}
        </h3>
        <a
          className="fw-bold fs-6 text-light"
          type="button"
          ref={btnCancela}
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between">
          <h3 className="col-12 m-0 mb-2 p-0 fw-bold border-bottom">
            Tipos de Productos/Servicios
          </h3>
          <div className="col-4 m-0 mb-2 p-0">
            <Input
              label="Código:"
              disabled={true}
              className="form-control col-md-4"
              name="idtipoproducto"
              value={values ? values.idtipoproducto : ""}
              id="inputCodigo"
              ref={txtIdc}
            />
          </div>

          <div className="col-4 m-0 mb-2 p-0 d-flex">
            <span className="col-auto fw-bold m-0 p-0 mr-2">
              Producto Informático:
            </span>
            <Radio
              label="Si"
              id="flexRadioDefault1"
              name="informatica"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              defaultChecked={
                props.tipopro && props.tipopro.informatica === true
                  ? true
                  : false
              }
              ref={txtRadioSi}
            />
            <Radio
              label="No"
              id="flexRadioDefault2"
              name="informatica"
              ref={txtRadioNo}
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              defaultChecked={
                props.tipopro && props.tipopro.informatica === false
                  ? true
                  : false
              }
            />
          </div>

          <div className="col-12 m-0 mb-2 p-0">
            <Textarea
              label="Descripción:"
              style={{ height: 70 }}
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              name="descripcion"
              onChange={onChange}
              defaultValue={values ? values.descripcion.trim() : ""}
              id="inputDescripcion"
              ref={txtDescrp}
            />
          </div>

          <h3 className="col-12 m-0 mb-2 p-0 fw-bold border-bottom">
            Cuenta Clasificar Presupuestario
          </h3>

          <div className="col-12 m-0 p-0 d-flex">
            <table class="col-11 m-0 p-0 table table-sm">
              <thead class="thead azulGradiant text-light">
                <tr>
                  <th scope="col" className="text-center ">
                    Ramo
                  </th>
                  <th scope="col" className="text-center ">
                    Gen
                  </th>
                  <th scope="col" className="text-center ">
                    Espec
                  </th>
                  <th scope="col" className="text-center ">
                    SubEsp
                  </th>
                  <th scope="col" className="text-center ">
                    Descripción
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">
                    {valuespuc
                      ? valuespuc.puc
                        ? valuespuc.puc.trim().substring(0, 3)
                        : ""
                      : ""}
                  </td>
                  <td className="text-center">
                    {valuespuc
                      ? valuespuc.puc
                        ? valuespuc.puc.trim().substring(3, 5)
                        : ""
                      : ""}
                  </td>
                  <td className="text-center">
                    {valuespuc
                      ? valuespuc.puc
                        ? valuespuc.puc.trim().substring(5, 7)
                        : ""
                      : ""}
                  </td>
                  <td className="text-center">
                    {valuespuc
                      ? valuespuc.puc
                        ? valuespuc.puc.trim().substring(7, 9)
                        : ""
                      : ""}
                  </td>
                  <td className="text-center">
                    {valuespuc
                      ? valuespuc.descripcion
                        ? valuespuc.descripcion.trim()
                        : ""
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="col-1 m-0 p-0 d-flex justify-content-center align-items-center">
              <button
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                onClick={catalogoPuc}
                className="btn btn-primary btn-sm rounded-circle"
              >
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>

          <h3 className="col-12 m-0 mb-2 p-0 fw-bold border-bottom">
            Cuenta Contable
          </h3>

          <div className="col-12 m-0 p-0 d-flex">
            <table class="col-11 m-0 p-0 table table-sm">
              <thead class="thead azulGradiant text-light">
                <tr>
                  <th scope="col" className="text-center ">
                    Codigo
                  </th>
                  <th scope="col" className="text-center ">
                    Cuenta Contable
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {valuescnt
                      ? valuescnt.idcuenta
                        ? valuescnt.idcuenta.trim()
                        : ""
                      : ""}
                  </td>
                  <td>
                    {valuescnt
                      ? valuescnt.codigocu
                        ? valuescnt.codigocu.trim().substring(0, 2)
                        : ""
                      : ""}
                    -
                    {valuescnt
                      ? valuescnt.codigocu
                        ? valuescnt.codigocu.trim().substring(2, 5)
                        : ""
                      : ""}
                    -
                    {valuescnt
                      ? valuescnt.codigocu
                        ? valuescnt.codigocu.trim().substring(5, 7)
                        : ""
                      : ""}
                    -
                    {valuescnt
                      ? valuescnt.codigocu
                        ? valuescnt.codigocu.trim().substring(7, 9)
                        : ""
                      : ""}
                    -
                    {valuescnt
                      ? valuescnt.codigocu
                        ? valuescnt.codigocu.trim().substring(9, 12)
                        : ""
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="col-1 m-0 p-0 d-flex align-items-center justify-content-center">
              <button
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                onClick={catalogoCuta}
                className="btn btn-primary btn-sm rounded-circle"
              >
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar} ref={btnCancela}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <TablaPuc
        show={mostrar3}
        onHideAceptaCatPuc={handleAceptarPuc}
        onHideCloseCatag={handleCloseCatag}
      />
      <TablaCuenta
        show={mostrar4}
        onHideAceptaCatCta={handleAceptarCta}
        onHideCloseCta={handleCloseCta}
      />
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
